var map = {
	"./angbao-bonus-cny.webp": 2538,
	"./angbao-bonus-dewali.webp": 2539,
	"./angbao-bonus-mooncake.webp": 2540,
	"./angbao-bonus-raya.webp": 2541,
	"./angbao-bonus-thaipusam.webp": 2542,
	"./angbao-bonus.webp": 2543,
	"./anni-lucky-draw.webp": 2544,
	"./cny-lucky-draw.webp": 2545,
	"./cny-promo.webp": 2546,
	"./dewali-promo.webp": 2547,
	"./dongzhi-angbao-bonus.webp": 2548,
	"./fifa-logo.webp": 2549,
	"./fifa-prediction.webp": 2550,
	"./fifa-qna.webp": 2551,
	"./uefa-predic.webp": 2552,
	"./welcome-cny-bonus.webp": 2553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2537;